/**
 * Maps menu icon slugs to registered XIcon component slugs.
 */
export const NAV_ICON_ALIASES = {
  cube: 'package',
  'map-pin': 'globe',
  truck: 'warehouse',
  'paper-airplane': 'package',
  buildings: 'identification-badge',
  'credit-card': 'wallet',
  collection: 'list-bullets',
  'squares-2x2': 'list-bullets',
  'chart-bar': 'chart-pie-slice',
  'check-circle': 'thumbs-up',
  bell: 'chat-circle-text',
  'exclamation-circle': 'chat-circle-text',
}

/**
 * Default icon when a slug cannot be resolved.
 */
export const NAV_ICON_FALLBACK = 'list-bullets'

/**
 * Registered solid nav icon slugs.
 */
export const AVAILABLE_NAV_ICONS = new Set([
  'academy',
  'address-book',
  'adjustments',
  'at',
  'bezier-curve',
  'brand-parsinta',
  'calendar',
  'chart-pie-slice',
  'chat-circle-text',
  'cog',
  'desktop',
  'globe',
  'google-logo',
  'graduation-cap',
  'hand-coins',
  'hand-shake',
  'head-circuit',
  'identification-badge',
  'layout-dashboard',
  'link',
  'list-bullets',
  'microsoft-teams-logo',
  'package',
  'phone-call',
  'projector-screen-chart',
  'school',
  'shopping-bag',
  'shopping-cart',
  'student',
  'swatches',
  'terminal-window',
  'thumbs-up',
  'tree-structure',
  'user-circle-minus',
  'user-list',
  'users-three',
  'wallet',
  'warehouse',
  'wrench',
])

/**
 * Resolve a menu icon slug to a registered XIcon slug.
 *
 * @param {string|null|undefined} name
 * @returns {string|null}
 */
export function resolveNavIcon(name) {
  if (!name) {
    return null
  }

  const normalized = `${name}`.trim().toLowerCase()
  const aliased = NAV_ICON_ALIASES[normalized] || normalized

  if (AVAILABLE_NAV_ICONS.has(aliased)) {
    return aliased
  }

  return NAV_ICON_FALLBACK
}

/**
 * Build the global Vue component name for a nav icon slug.
 *
 * @param {string|null|undefined} name
 * @returns {string|null}
 */
export function navIconComponentName(name) {
  const resolved = resolveNavIcon(name)

  if (!resolved) {
    return null
  }

  return `x-icon-solid-${resolved}`
}
